var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewSubmitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 25C1 11.7452 11.7452 1 25 1V1C38.2548 1 49 11.7452 49 25V25C49 38.2548 38.2548 49 25 49V49C11.7452 49 1 38.2548 1 25V25Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.59 16.59C28.21 16.21 27.7 16 27.17 16H18C16.9 16 16.01 16.9 16.01 18L16 32C16 33.1 16.89 34 17.99 34H32C33.1 34 34 33.1 34 32V22.83C34 22.3 33.79 21.79 33.41 21.42L28.59 16.59ZM21 30C20.45 30 20 29.55 20 29C20 28.45 20.45 28 21 28C21.55 28 22 28.45 22 29C22 29.55 21.55 30 21 30ZM21 26C20.45 26 20 25.55 20 25C20 24.45 20.45 24 21 24C21.55 24 22 24.45 22 25C22 25.55 21.55 26 21 26ZM21 22C20.45 22 20 21.55 20 21C20 20.45 20.45 20 21 20C21.55 20 22 20.45 22 21C22 21.55 21.55 22 21 22ZM27 22V17.5L32.5 23H28C27.45 23 27 22.55 27 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewSubmitIcon);
export default __webpack_public_path__ + "static/media/review_submit_icon.3af0b6f584a4ae717a8d6e0acf0551fd.svg";
export { ForwardRef as ReactComponent };